import handleSagaError from '../../redux/handleSagaError';
import { apiClient } from '../../utils';

const rejectInvoice = async ({ orderId, description, rejectType }) =>
  orderId &&
  description &&
  rejectType &&
  apiClient
    .post('/merchant/order/reject', {
      data: { orderId, description, rejectType },
    })
    .then(({ result }) => result)
    .catch(handleSagaError);

export { rejectInvoice };
